export default __webpack_public_path__ + "97e1acd8ce9fa2e59a5479c61b6fba23.gif";